import React from "react";
import { Flex, Text, TextField, Select, IconButton } from "@radix-ui/themes";
import { ArrowRightIcon } from "@radix-ui/react-icons";
import {
  LEAT_SOURCE_FIELDS,
  NONE_LEAT_ATTRIBUTE,
  buildLeatAttributeOptions,
  fromSelectValue,
  toSelectValue,
} from "./leatFieldMappings";

function MappingRow({ leftLabel, right, isHeader = false }) {
  return (
    <Flex
      style={{ alignSelf: "stretch" }}
      display="flex"
      justify="between"
      align="center"
      gap="2"
    >
      <Flex direction="column" gap="2" style={{ flex: 1, minWidth: 0 }}>
        {isHeader ? (
          <Text size="2" weight="medium" style={{ height: "24px", display: "flex", alignItems: "center" }}>
            b connect
          </Text>
        ) : null}
        <TextField.Root variant="surface" value={leftLabel} size="2" disabled style={{ width: "100%" }} />
      </Flex>

      <Flex direction="column" gap="2" style={{ paddingTop: isHeader ? "40px" : "8px" }}>
        <IconButton size="2" variant="ghost" color="gray" style={{ pointerEvents: "none" }}>
          <ArrowRightIcon width="16" height="16" />
        </IconButton>
      </Flex>

      <Flex display="flex" direction="column" gap="2" style={{ flex: 1, minWidth: 0 }}>
        {isHeader ? (
          <Text size="2" weight="medium" style={{ height: "24px", display: "flex", alignItems: "center" }}>
            Leat
          </Text>
        ) : null}
        {right}
      </Flex>
    </Flex>
  );
}

export function LeatDataFieldsSection({
  fieldMappings,
  attributes,
  onChange,
  disabled = false,
}) {
  const options = buildLeatAttributeOptions(attributes, fieldMappings);

  return (
    <Flex display="flex" direction="column" gap="4" style={{ flex: 1, width: "100%" }}>
      <MappingRow
        isHeader
        leftLabel="Email address"
        right={
          <Select.Root value="email" disabled size="2">
            <Select.Trigger style={{ width: "100%" }} variant="surface" />
            <Select.Content>
              <Select.Item value="email">Email address</Select.Item>
            </Select.Content>
          </Select.Root>
        }
      />

      {LEAT_SOURCE_FIELDS.map((field) => {
        const mappedValue = toSelectValue(fieldMappings?.[field.source]);
        return (
          <MappingRow
            key={field.source}
            leftLabel={field.label}
            right={
              <Select.Root
                value={mappedValue}
                onValueChange={(value) => onChange(field.source, fromSelectValue(value))}
                disabled={disabled}
                size="2"
              >
                <Select.Trigger style={{ width: "100%" }} variant="surface" placeholder="Don't sync" />
                <Select.Content>
                  <Select.Item value={NONE_LEAT_ATTRIBUTE}>Don't sync</Select.Item>
                  {options.map((option) => (
                    <Select.Item key={option.name} value={option.name} title={option.name}>
                      {option.label}
                    </Select.Item>
                  ))}
                </Select.Content>
              </Select.Root>
            }
          />
        );
      })}
    </Flex>
  );
}
